export default {
  login: {
    title: '¡Bienvenido a Bioflux Trading!',
    form: {
      usernameLabel: 'Usuario',
      passwordLabel: 'Contraseña',
      forgotPassword: '¿Olvidaste tu contraseña?',
      createAccount: 'Crear cuenta',
      loginButton: 'Iniciar sesión',
      signInWithMoeveEmployee: 'Iniciar sesión con cuenta de empleado',
      contactSupport:
        'Si tienes problemas para iniciar sesión, por favor contacta al soporte: biofluxtrading@moeveglobal.com',
    },
    forgotPassword: {
      title: 'Restaurar contraseña',
      form: {
        usernameLabel: 'Usuario',
        codeLabel: 'Código',
        newPasswordLabel: 'Nueva contraseña',
        confirmPasswordLabel: 'Confirmar contraseña',
        setNewPasswordButton: 'Establecer nueva contraseña',
        backButton: 'Volver',
      },
    },
  },
  createAccount: {
    title: 'Crear cuenta',
    form: {
      companyNameLabel: 'Nombre de la empresa',
      adminNameLabel: 'Nombre del manager de la empresa',
      adminEmailLabel: 'Email del manager de la empresa',
      cupsLabel: 'Cups',
      cupsAliasLabel: 'Alias',
      consumerLabel: 'Consumidor',
      producerLabel: 'Productor',
      createAccountButton: 'Crear cuenta',
      backButton: 'Volver',
    },
  },
  newPassword: {
    title: 'Nueva contraseña requerida',
    form: {
      passwordLabel: 'Contraseña',
      confirmPasswordLabel: 'Confirmar contraseña',
      setNewPasswordButton: 'Establecer nueva contraseña',
      backButton: 'Volver',
    },
  },
  home: {
    consumerCard: {
      title: 'Consumidor de Gas',
      description: 'Gestiona tu consumo de gas y compáralo con los datos de Enagas',
    },
    producerCard: {
      title: 'Productor de Biometano',
      description: 'Gestiona tu producción de biometano y compárala con los datos de Enagas',
    },
    settingsCard: {
      title: 'Configuración',
      description: 'Gestiona la configuración de tu empresa, como CUPS y usuarios',
    },
    sidebar: {
      home: 'Inicio',
      gasConsumer: 'Consumidor de Gas',
      settings: 'Configuración',
    },
    logout: 'Cerrar sesión',
    language: 'Cambiar idioma',
    reportIssue: 'Reportar problema',
  },
  settings: {
    moeveActionsTab: {
      title: 'Acciones de Moeve',
      pendingActions: {
        title: 'Acciones pendientes',
        emptyMessage: 'No hay acciones pendientes',
        types: {
          createCompany: 'Crear empresa',
          createCups: 'Crear Cups',
          createMoeveUser: 'Crear usuario de Moeve',
        },
        columns: {
          type: 'Tipo',
          company: 'Empresa',
          action: 'Acción',
        },
      },
      activeCompanies: {
        title: 'Empresas activas',
        emptyMessage: 'No hay empresas activas',
        columns: {
          company: 'Empresa',
          cups: 'CUPS',
          alias: 'Alias',
          associatedTo: 'Asociado a',
          consumer: 'Consumidor',
          producer: 'Productor',
        },
      },
      moeveUserModal: {
        title: 'Por favor selecciona un rol y una empresa si es necesario',
        roleLabel: 'Rol',
        companyLabel: 'Empresa',
        submitButton: 'Enviar',
        errorRole: 'El rol es obligatorio',
        errorCompany: 'La empresa es obligatoria para usuarios no administradores',
      },
    },
    companyDetailsTab: {
      title: 'Detalles de la empresa',
      company: 'Empresa',
      noCompanySelectedMessage: 'No hay empresa seleccionada, por favor selecciona una empresa para ver los detalles',
      companyCups: {
        title: 'Cups de la empresa',
        addCupsButton: 'Añadir Cups',
        emptyMessage: 'No hay Cups para mostrar',
        columns: {
          cups: 'Cups',
          alias: 'Alias',
          users: 'Usuarios',
          status: 'Estado',
        },
        modal: {
          createCupsTitle: 'Crear Cups',
          updateCupsTitle: 'Actualizar Cups',
          identifierLabel: 'Identificador',
          aliasLabel: 'Alias',
          usersLabel: 'Usuarios',
          createCupsButton: 'Crear',
          updateCupsButton: 'Actualizar',
        },
      },
      companyUsers: {
        title: 'Usuarios de la empresa',
        addUsersButton: 'Añadir usuarios',
        emptyMessage: 'No hay usuarios para mostrar',
        columns: {
          name: 'Nombre',
          email: 'Email',
          associatedTo: 'Asociado a',
          role: 'Rol',
        },
        modal: {
          createUsersTitle: 'Crear usuario',
          updateUsersTitle: 'Actualizar usuario',
          nameLabel: 'Nombre',
          emailLabel: 'Email',
          managerLabel: 'Manager',
          userLabel: 'Usuario',
          associatedCupsLabel: 'Cups asociadas',
          createUsersButton: 'Crear',
          updateUsersButton: 'Actualizar',
        },
      },
    },
  },
  consumer: {
    filters: {
      dateRangeLabel: 'Rango de fechas',
      companyLabel: 'Empresa',
      cupsLabel: 'Cups - Alias',
      pleaseSelectCompanyFirst: 'Por favor selecciona una empresa primero',
    },
    buttons: {
      applyLabel: 'Aplicar',
      exportLabel: 'Exportar',
    },
    noFiltersPanel: {
      noFiltersMessage: 'Por favor selecciona filtros para mostrar datos',
      instructionMessage: "Selecciona los filtros y presiona 'Aplicar' para visualizar la información",
    },
    tablePanel: {
      averages: {
        nomination: 'Nominación promedio',
        enagas: 'Enagas promedio',
      },
      columns: {
        date: 'Fecha',
        nomination: 'Nominación (kWh)',
        enagas: 'Enagas',
        difference: 'Diferencia',
        cups: 'Cups - Alias',
      },
      tooltip: {
        updatedBy: 'Actualizado por',
        pleaseInsertValueInKwh: 'Por favor inserta un valor en kWh',
      },
    },
    chartPanel: {
      yLabel: 'Volumen (kWh)',
      averages: {
        nomination: 'Nominación promedio',
        enagas: 'Enagas promedio',
      },
    },
  },
  services: {
    updateConsumptions: {
      sucessTitle: 'Consumos actualizados correctamente',
      successMessage: '{{count}} consumo(s) han sido actualizados correctamente',
    },
    getConsumptions: {
      warning: 'Advertencia',
      message: 'No hay datos para el rango de fechas seleccionado',
    },
    activeCompanies: {
      companyTypeChanged: 'Tipo de empresa cambiado correctamente',
      companyDeleted: 'Empresa eliminada correctamente',
    },
    companyDetails: {
      createCupsSuccess: 'Cups creada correctamente',
      updateCupsSuccess: 'Cups actualizada correctamente',
      deleteCupsSuccess: 'Cups eliminada correctamente',
      createUserSuccess: 'Usuario creado correctamente',
      updateUserSuccess: 'Usuario actualizado correctamente',
      deleteUserSuccess: 'Usuario eliminado correctamente',
      deleteCurrentUserError: 'No puedes eliminar el usuario con el que estás actualmente logueado',
    },
    pendingActions: {
      actionStatusChanged: 'Estado de la acción cambiado correctamente',
    },
    registerUser: {
      success: 'Usuario registrado correctamente, por favor espera la aprobación',
    },
  },
  errors: {
    consumer: {
      errorConsumerTable: 'Error al obtener los datos de la tabla de consumos',
      errorConsumerChart: 'Error al obtener los datos del gráfico de consumos',
      errorUpdateConsumptions: 'Error al actualizar los consumos',
      errorExportConsumptions: 'Error al exportar los consumos',
    },
    masters: {
      errorGetMasters: 'Error al obtener los datos de los maestros',
    },
    companyDetails: {
      errorGetCompanyDetails: 'Error al obtener los datos de la empresa',
      errorCreatePlant: 'Error al crear la planta',
      errorUpdatePlant: 'Error al actualizar la planta',
      errorDeletePlant: 'Error al eliminar la planta',
      errorCreateCompanyUser: 'Error al crear el usuario de la empresa',
      errorUpdateCompanyUser: 'Error al actualizar el usuario de la empresa',
      errorDeleteCompanyUser: 'Error al eliminar el usuario de la empresa',
    },
    moeveActions: {
      errorGetPendingActions: 'Error al obtener las acciones pendientes',
      errorChangeActionStatus: 'Error al cambiar el estado de la acción',
      errorGetActiveCompanies: 'Error al obtener las empresas activas',
      errorChangeCompanyType: 'Error al cambiar el tipo de empresa',
      errorDeleteCompany: 'Error al eliminar la empresa',
    },
    auth: {
      errorGetCurrentUser: 'Error al obtener el usuario actual',
      errorRegisterUser: 'Error al registrar el usuario',
    },
  },
  reportIssueModal: {
    title: 'Reportar un problema',
    message: 'Si necesita reportar un problema puede indicarlo mandando un email a la dirección',
  },
};
